import { render, staticRenderFns } from "./comp_part.vue?vue&type=template&id=cea15b1a&scoped=true"
import script from "./comp_part.vue?vue&type=script&lang=js"
export * from "./comp_part.vue?vue&type=script&lang=js"
import style0 from "./comp_part.vue?vue&type=style&index=0&id=cea15b1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea15b1a",
  null
  
)

export default component.exports